<template>
  <span class="loading inline-block" />
</template>
  
<script>
export default {
  name: "LoadingComponent",
};
</script>